import React, { FunctionComponent } from 'react';
import styles from './square-employee-box.module.scss';
import { IEmployeeBoxProps } from '../employee-box/employee-box';
import { InternalLink } from '../internal-link/internal-link';
import { authorUrl } from '../../utils/utils';
import faceLess from '../../assets/images/faceless.webp';

export const SquareEmployeeBox: FunctionComponent<IEmployeeBoxProps> = props => {
  const {
    firstName,
    lastName,
    position,
    photoUrl,
    hasAuthorPage,
    slug
  } = props;
  const content = (
    <div className={styles.employeeBoxContainer}>
      <div className={styles.imageWrapper}>
        <img
          src={photoUrl ? photoUrl : faceLess}
          alt={`Person ${firstName} ${lastName}`}
          className={styles.personImg}
        />
        <div className={styles.employeeBoxData}>
          <div
            className={styles.personHeader}
          >{`${firstName} ${lastName}`}</div>
          <div className={styles.personPosition}>{position}</div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {hasAuthorPage ? (
        <InternalLink url={authorUrl(slug)}>{content}</InternalLink>
      ) : (
        content
      )}
    </React.Fragment>
  );
};
